export default "__VITE_ASSET__BdUWeMwW__"